<app-floating-menu
  [(opened)]="opened"
  [container]="container"
  openTrigger="mouseover"
  [closeOnMouseleave]="true"
  [contentHeight]="cardHeight"
  [closedIndicatorHeight]="cardHeight"
  *ngIf="!isMobileScreen"
>
  <ng-template floatingMenuContent>
    <app-card class="card-menu" shapeType="rounded">
      <ng-template [ngTemplateOutlet]="menuTpl"></ng-template>
    </app-card>
  </ng-template>
</app-floating-menu>

<app-bottom-sheet
  *ngIf="isMobileScreen"
  [(opened)]="opened"
  height="50vh"
  [container]="container"
  [showHeader]="false"
  [overlayMask]="false"
>
  <ng-template bottomSheetContent>
    <div class="bottom-sheet-menu">
      <ng-template [ngTemplateOutlet]="menuTpl"></ng-template>
    </div>
  </ng-template>
</app-bottom-sheet>

<ng-template #menuTpl>
  <div class="toc-menu">
    <app-toolbar
      class="toolbar"
      [ngClass]="{ 'btn-go-back-visible': !!menuItemSelected }"
    >
      <div
        appToolbarItemBefore
        *ngIf="!!menuItemSelected"
        class="btn-item"
        #btnGoBackContainerEl
      >
        <app-button
          class="btn-go-back"
          buttonType="normal"
          styleType="text"
          shapeType="circle"
          sizeType="small"
          marginType="icon"
          icon="assets/icons/chevron-left.svg"
          (click)="onBtnGoBackClick()"
        ></app-button>

        <app-tooltip
          [target]="btnGoBackContainerEl"
          verticalAlignment="top"
          horizontalAlignment="center"
        >
          {{ this.ts.getCurrentLanguage()['back'] }}
        </app-tooltip>
      </div>

      <div appToolbarItemBefore class="title">{{this.ts.getCurrentLanguage()['themes']}}</div>

      <div
        appToolbarItemAfter
        class="btn-item"
        #btnDisableAllLayersContainerEl
        *ngIf="isBtnDisableLayersVisible"
      >
        <app-button
          class="btn-go-back"
          [buttonType]="isBtnDisableLayersDisabled ? 'normal' : 'primary'"
          styleType="text"
          shapeType="circle"
          sizeType="normal"
          marginType="icon"
          icon="assets/icons/close-layers.svg"
          (click)="onBtnDisableLayers()"
          [disabled]="isBtnDisableLayersDisabled"
        ></app-button>

        <app-tooltip
          [target]="btnDisableAllLayersContainerEl"
          verticalAlignment="top"
          horizontalAlignment="center"
        >
          {{ this.ts.getCurrentLanguage()['turnoff-layers'] }}
        </app-tooltip>
      </div>

      <div
        appToolbarItemAfter
        class="search-container"
        *ngIf="searchInputVisible"
      >
        <app-input-box
          class="input-search"
          [(value)]="searchText"
          (valueChange)="onSearchTextChanged($event)"
          placeholder="{{ searchPlaceholder }}"
          [showErrorEnabled]="false"
        ></app-input-box>
      </div>

      <div
        appToolbarItemAfter
        class="btn-item"
        #btnPinContainerEl
        *ngIf="!isMobileScreen"
      >
        <app-button
          class="btn-pin"
          [buttonType]="isFloatingMenuFixed ? 'primary' : 'normal'"
          styleType="text"
          shapeType="circle"
          sizeType="small"
          marginType="icon"
          icon="assets/icons/pin.svg"
          (click)="isFloatingMenuFixed = !isFloatingMenuFixed"
        ></app-button>

        <app-tooltip
          [target]="btnPinContainerEl"
          verticalAlignment="top"
          horizontalAlignment="center"
        >
          {{ !isFloatingMenuFixed ?  this.ts.getCurrentLanguage()['dock'] : this.ts.getCurrentLanguage()['undock'] }}
        </app-tooltip>
      </div>

      <div appToolbarItemAfter class="btn-item" *ngIf="isMobileScreen">
        <app-button
          appToolbarItemAfter
          class="close-btn"
          buttonType="normal"
          styleType="text"
          shapeType="circle"
          icon="assets/icons/xmark.svg"
          (click)="opened = false"
        ></app-button>
      </div>
    </app-toolbar>

    <div class="menu-items-list-container" [hidden]="!!menuItemSelected">
      <app-list class="list" [items]="menuItems">
        <ng-template listItem let-item="item">
          <div
            *ngIf="!(item.visible === false)"
            class="menu-item"
            [ngClass]="{ active: !!item.enabled }"
            (click)="onMenuItemClick(item)"
          >
            <app-iconic class="icon" [icon]="item.icon"></app-iconic>

            <div class="text">{{ item.label ?? item.title }}</div>
          </div>
        </ng-template>
      </app-list>
    </div>

    <div class="menu-item-content-screen" [hidden]="!menuItemSelected">
      <ng-template
        [ngTemplateOutlet]="contentScreenTpl"
        [ngTemplateOutletContext]="dataContext"
      ></ng-template>
    </div>
  </div>
</ng-template>

<ng-template #basemapGalleryScreenTpl>
  <app-basemap-gallery
    [(selectedIndex)]="basemapSelectedIndex"
    [basemapItems]="basemapList"
    [allowDeselect]="true"
    (onBasemapItemSelected)="onBasemapItemSelected($event)"
  ></app-basemap-gallery>
</ng-template>

<ng-template #defaultContentScreenTpl let-menuItem="menuItem">
  <app-layer-list
    class="layer-list"
    [menuItem]="menuItem"
    [mapView]="mapView"
    [searchText]="searchTextToApply"
  ></app-layer-list>
</ng-template>
